<template>
    <div>
        <div v-if="user">
            <div class="user-avatar">
                <img v-if="user.profile_image" class="user-avatar-img" :src="$utils.getImage(user.profile_image, 64, 64, false)"
                     :class="{'xs': size === 'xs', 'small': size === 'small', 'medium': size === 'medium', 'large': size === 'large'}">
                <img v-else
                     id="user_avatar"
                     class="user-avatar-img"
                     :class="{'xs': size === 'xs', 'small': size === 'small', 'medium': size === 'medium', 'large': size === 'large'}"
                     src="/assets/img/default_avatar.svg">
                <div v-if="displayName" class="user-avatar-info">
                    <div style="font-weight: 600">
                        {{ user.name }} <span v-if="timeAgo" class="user-avatar-info__time-ago ms-1">{{timeAgo}}</span>
                    </div>
                    <div v-if="subtitle" v-html="subtitle" class="user-avatar-info__subtitle text-capitalize"></div>
                    <div v-if="displayEmail" class="user-avatar-info__subtitle">{{ user.email }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserAvatar',
    props: ['user', 'subtitle', 'size', 'displayName', 'displayEmail', 'timeAgo']
};

</script>
